import { useMemo, useEffect, useRef } from 'react';
import { useAuth } from '../../../utils/Auth';
import QRCodeStyling from '@plasticprintersinc/pp-qr-code';

export default function QrRef({size, childQrOptions = null}) {

    const { qr_options: authQrOptions } = useAuth();

    const qr_options = useMemo(() => {
        if (childQrOptions) {
            if (!size) {
                return childQrOptions
            } else {
                return {
                    ...childQrOptions,
                    width: size,
                    height: size
                }
            }
        } else {
            if (!size) {
                return authQrOptions
            } else {
                return {
                    ...authQrOptions,
                    width: size,
                    height: size
                }
            }
        }
    },[childQrOptions, authQrOptions, size]);
    
    const QR = useMemo(() => new QRCodeStyling(qr_options), []);
    const qrRef = useRef(null);
    
    useEffect(() => {
        if (qrRef.current) QR.append(qrRef.current).catch(err => {console.log(err)})
    }, [QR, qrRef]);

    useEffect(() => {
        if (!QR) return;
        QR.update(qr_options);
    }, [QR, qr_options]);

    return (
        <div ref={qrRef} />
    );
};